import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService, Destroy, Guard, NullEntity, ViewMode, BreadCrumbService } from '@kpd/framework-ngx';
import { UserManagementEntityUpdater } from 'app/shared/services/entity-updater';
import { RoleFacade } from 'app/shared/services/facades/role.facade';
import { RolesNavigatorHelper } from 'app/roles/roles-navigator-helper';
import { Role } from 'app/shared/models/role';
import { RoleService } from 'app/shared/services/role.service';
import { RoleKey } from 'app/shared/models/keys/role-key';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-roles-details',
  templateUrl: './role-details.component.html',
})
export class RoleDetailsComponent implements OnInit, OnDestroy {
  Permissions: typeof Permissions = Permissions;

  currentItem: Role | NullEntity = new Role();
  originalShouldReuseRouteFn: any;
  entityUpdater: UserManagementEntityUpdater;
  viewMode = ViewMode.Consult;
  tabLabels = {
    permissionSetsCount: 0,
    userCount: 0,
  };

  @Destroy()
  destroy$: any;

  constructor(
    dialogService: DialogService,
    guard: Guard,
    public navigatorHelper: RolesNavigatorHelper,
    public roleFacade: RoleFacade,
    private route: ActivatedRoute,
    private roleService: RoleService,
    breadCrumbService: BreadCrumbService,
  ) {
    this.entityUpdater = new UserManagementEntityUpdater(
      dialogService,
      this.navigatorHelper,
      this.roleFacade,
      guard,
      breadCrumbService,
      'roles',
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.viewMode = params['mode'];
    });
  }

  onClose(): void {
    this.navigatorHelper.back();
  }

  onItemChanged(event: Role): void {
    if (event instanceof NullEntity) {
      this.currentItem = new Role();
      return;
    }
    if (event && event.key) {
      this.roleService.getRoleUsers(event.key as RoleKey).subscribe(users => {
        this.tabLabels.userCount = users.length;
        if (event.permissionSets) {
          this.changeTabLabel('permissionSetsCount', event.permissionSets.length);
        }
      });
    }
    this.currentItem = event;
  }

  onSwitchMode(mode: string): void {
    this.navigatorHelper.navigateByQueryString({ tab: this.route.snapshot.queryParams['tab'], mode });
  }

  showInEditPermission(
    editPermission: string | string[],
    defaultPermission: string | string[] = 'Role.Read',
  ): string | string[] {
    return this.viewMode === ViewMode.Edit ? editPermission : defaultPermission;
  }

  changeTabLabel(tab: string, amount: number): void {
    this.tabLabels[tab] = amount;
  }

  ngOnDestroy(): void {
    this.entityUpdater.destroy();
  }
}
